__turbopack_context__.v({
  "contentContainer": "HeroImage-module-scss-module__1prSea__contentContainer",
  "heading": "HeroImage-module-scss-module__1prSea__heading",
  "imageContainer": "HeroImage-module-scss-module__1prSea__imageContainer",
});
